import { atomWithStorage } from 'jotai/utils';

/**
 * Whether audio notification is enabled on response completion.
 * Persisted to localStorage. Default: OFF — sound requires user opt-in.
 */
export const soundEnabledAtom = atomWithStorage<boolean>('blockpedia-sound-enabled', false);
